import React from 'react';

import { withAppState } from '../../../shared/containers/containerAppState'

import FirstTitle from '../../../shared/items/static/firstTitle'
import TitleClosedBarWrapper from './../../../shared/titleClosedBarWrapper'

const REPORTS_BAR_TITLE = "Отчёты"

const ReportsTitleClosedBar = props => {
  return !props.isSideBarOpen
    ? <TitleClosedBarWrapper>
      <FirstTitle>
        {REPORTS_BAR_TITLE}
      </FirstTitle>
    </TitleClosedBarWrapper>
    : null
}

export default withAppState(React.memo(ReportsTitleClosedBar))
